import { render, staticRenderFns } from "./ChannelActionBar.vue?vue&type=template&id=5de54c70"
import script from "./ChannelActionBar.vue?vue&type=script&lang=js"
export * from "./ChannelActionBar.vue?vue&type=script&lang=js"
import style0 from "./ChannelActionBar.vue?vue&type=style&index=0&id=5de54c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports